import { api } from './client';

/** Перегляд форм фінансової звітності без документа (ч.1386: + 1-м/2-м, 1-мс/2-мс, попередження). */
export type FinReportFormCode = '1' | '2' | '1m' | '2m' | '1ms' | '2ms' | '3' | '4';

export interface FinReportLine {
  line_code: string;
  line_name: string;
  section: string | null;
  order_no: number;
  is_total: boolean;
  is_negative: boolean;
  parent_line: string | null;
  is_manual: boolean;
  column_start: string;
  column_end: string;
  /** Ф4: графи матриці G3…G10 (ч.1388) */
  cells?: Record<string, string> | null;
}

export interface FinReport {
  form_code: string;
  form_name: string;
  period_start: string;
  period_end: string;
  organization_ids: string[];
  scope: 'organization' | 'organizations' | 'tenant';
  lines: FinReportLine[];
  warnings: string[];
}

export const financialReports = {
  get: (params: {
    form_code: FinReportFormCode;
    period_start: string;
    period_end: string;
    // Один з режимів:
    //  - organization_id: один — регламентна форма;
    //  - organization_ids: кілька — зведений по обраних юрособах;
    //  - нічого не передано — наскрізний P&L по всьому tenant (лише форми-обороти).
    organization_id?: string;
    organization_ids?: string[];
  }) =>
    api.get<FinReport>(`/financial-reports/${params.form_code}`, {
      params: {
        period_start: params.period_start,
        period_end: params.period_end,
        organization_id: params.organization_id,
        organization_ids: params.organization_ids,
      },
    }).then((r) => r.data),
};
